import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Curve } from '../core/Curve.js';
import { Vector2 } from '../../math/Vector2.js';

var EllipseCurve = /*#__PURE__*/function (_Curve) {
  _inherits(EllipseCurve, _Curve);

  var _super = _createSuper(EllipseCurve);

  function EllipseCurve() {
    var _this;

    var aX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var aY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var xRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var yRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var aStartAngle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var aEndAngle = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.PI * 2;
    var aClockwise = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var aRotation = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

    _classCallCheck(this, EllipseCurve);

    _this = _super.call(this);
    _this.type = 'EllipseCurve';
    _this.aX = aX;
    _this.aY = aY;
    _this.xRadius = xRadius;
    _this.yRadius = yRadius;
    _this.aStartAngle = aStartAngle;
    _this.aEndAngle = aEndAngle;
    _this.aClockwise = aClockwise;
    _this.aRotation = aRotation;
    return _this;
  }

  _createClass(EllipseCurve, [{
    key: "getPoint",
    value: function getPoint(t, optionalTarget) {
      var point = optionalTarget || new Vector2();
      var twoPi = Math.PI * 2;
      var deltaAngle = this.aEndAngle - this.aStartAngle;
      var samePoints = Math.abs(deltaAngle) < Number.EPSILON; // ensures that deltaAngle is 0 .. 2 PI

      while (deltaAngle < 0) {
        deltaAngle += twoPi;
      }

      while (deltaAngle > twoPi) {
        deltaAngle -= twoPi;
      }

      if (deltaAngle < Number.EPSILON) {
        if (samePoints) {
          deltaAngle = 0;
        } else {
          deltaAngle = twoPi;
        }
      }

      if (this.aClockwise === true && !samePoints) {
        if (deltaAngle === twoPi) {
          deltaAngle = -twoPi;
        } else {
          deltaAngle = deltaAngle - twoPi;
        }
      }

      var angle = this.aStartAngle + t * deltaAngle;
      var x = this.aX + this.xRadius * Math.cos(angle);
      var y = this.aY + this.yRadius * Math.sin(angle);

      if (this.aRotation !== 0) {
        var cos = Math.cos(this.aRotation);
        var sin = Math.sin(this.aRotation);
        var tx = x - this.aX;
        var ty = y - this.aY; // Rotate the point about the center of the ellipse.

        x = tx * cos - ty * sin + this.aX;
        y = tx * sin + ty * cos + this.aY;
      }

      return point.set(x, y);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(EllipseCurve.prototype), "copy", this).call(this, source);

      this.aX = source.aX;
      this.aY = source.aY;
      this.xRadius = source.xRadius;
      this.yRadius = source.yRadius;
      this.aStartAngle = source.aStartAngle;
      this.aEndAngle = source.aEndAngle;
      this.aClockwise = source.aClockwise;
      this.aRotation = source.aRotation;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(EllipseCurve.prototype), "toJSON", this).call(this);

      data.aX = this.aX;
      data.aY = this.aY;
      data.xRadius = this.xRadius;
      data.yRadius = this.yRadius;
      data.aStartAngle = this.aStartAngle;
      data.aEndAngle = this.aEndAngle;
      data.aClockwise = this.aClockwise;
      data.aRotation = this.aRotation;
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(EllipseCurve.prototype), "fromJSON", this).call(this, json);

      this.aX = json.aX;
      this.aY = json.aY;
      this.xRadius = json.xRadius;
      this.yRadius = json.yRadius;
      this.aStartAngle = json.aStartAngle;
      this.aEndAngle = json.aEndAngle;
      this.aClockwise = json.aClockwise;
      this.aRotation = json.aRotation;
      return this;
    }
  }]);

  return EllipseCurve;
}(Curve);

EllipseCurve.prototype.isEllipseCurve = true;
export { EllipseCurve };